(function () {
    'use strict';

    angular
        .module('homeDashboardControllers')
        .controller('DashboardInitiativeUpdateStatusController', Controller);

    Controller.$inject = ['$scope', '$state', 'businessPlanningService', 'grcGovernanceProcessService', 'permissionService'];

    function Controller($scope, $state, businessPlanningService, grcGovernanceProcessService, permissionService) {

        // Get Lookups
        businessPlanningService
            .getPlanLookups()
            .then(function (lookups) {
                $scope.planLookups = lookups;
            });

        // Get Active process
        grcGovernanceProcessService
            .getActiveInitiativeUpdateStatus()
            .then(function (govProcess) {

                var isGovProcDisabled = !_.isObject(govProcess) || _.isUndefined(govProcess.GovernanceProcessID);
                if (isGovProcDisabled) return;

                $scope.governanceProcess = govProcess;

                // Get Owners and Status
                businessPlanningService
                        .getOwnersAndStatus({ ignoreError: true })
                        .then(function (statusOwners) {
                            $scope.statusOwners = statusOwners;
                        });
            });

        // Has Permission
        $scope.hasPermission = function () {
            var statePermissions = $state.get('initiativeUpdateStatusOwnerList').data.permissions;

            return permissionService.hasPermission(
                statePermissions.featureRole,
                statePermissions.key,
                statePermissions.permission)
        };

        // Go to Initiative Update Status
        $scope.gotToInitiativeUpdateStatus = function () {
            // No owners, go to Eligible For Assessment
            if (!$scope.statusOwners.length) {
                $state.go('initiativeUpdateStatusEligibleForAssessment');
                return;
            }

            $state.go('initiativeUpdateStatusOwnerList');
        };

        // Get Status
        $scope.getStatusCount = function (status) {
            return _.filter($scope.statusOwners, { OwnerStatusValue: status }).length;
        };

        // Get Completion percentage
        $scope.getCompletionPercentage = function () {
            if (_.isUndefined($scope.statusOwners)) { return; }

            var completedCount = _.filter($scope.statusOwners, { OwnerStatusValue: 'Completed' }).length;
            var totalCount = $scope.statusOwners.length;
            var percentage = (completedCount / totalCount) * 100;

            return percentage || 0;
        };
    }
})();